/* eslint-disable global-require */
import Vue from 'vue';
import PortalVue from 'portal-vue';
import { createInertiaApp } from '@inertiajs/inertia-vue';
import { InertiaProgress } from '@inertiajs/progress';
import store from './store';

const moment = require('moment');
window.axios = require('axios');
window._ = require('lodash');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.locale = window.navigator.userLanguage || window.navigator.language;

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
try {
  window.Popper = require('popper.js').default;
  // eslint-disable-next-line no-multi-assign
  window.$ = window.jQuery = require('jquery');
  require('bootstrap');
} catch (e) {
  //
}

Vue.config.productionTip = false;
Vue.mixin({
  methods: {
    route: window.route,
  },
});
Vue.use(PortalVue);

Vue.filter('localDate', (value) => moment.utc(value).local().format('DD MMM YYYY'));
Vue.filter('localDateTime', (value) => moment.utc(value).local().format('DD MMM YYYY h:mma'));

InertiaProgress.init()
createInertiaApp({
  resolve: (name) => require(`./Pages/${name}`),
  setup({ el, app, props }) {
    new Vue({
      store,
      render: (h) => h(app, props),
    }).$mount(el);
  },
});
